module.exports = __webpack_public_path__ + "img/red_042.60094e16.png";